import { DealerReviewsSortType } from '@/typings/model';

export const defaultReviewsSort: DealerReviewsSortType = 'rating_desc';
export const defaultReviewsLimit = 4;
